import { Link } from "react-router-dom";

const TermsConditionsFooter = () => {
  window.scrollTo(0, 0);
  return (
    <>
      <div className="container mt-4 mb-5">
        <h2 className="text-center text-primary-new fw-bold mb-5">
          Terms and Conditions
        </h2>

        <p className="text-dark">
          In using websites and applications owned by Next Health Media LLC, including
          those at reachello.com and their subdomains, including for purchase
          and/or use of our services or products, you are deemed to have read
          and agreed to the following Terms of Use:
        </p>

        <h4 className="text-primary-new fw-bold">Terminology</h4>

        <div className="text-dark">
          <p>
            The following terminology applies to these Terms and Conditions,
            including our Privacy Policy found at{" "}
            <Link
              to="/privacy-policy"
              className="text-primary fw-bold text-decoration-none"
            >
              Privacy policy
            </Link>
            , the Disclaimer Notice, and any or all Agreements between us:
          </p>

          <p>
            “Client”, “User”, “You” and “Your” refers to you, the person
            accessing this website and accepting the Company's Terms and
            Conditions. In case the person accessing this website is doing so on
            behalf of an organization such as a business, municipality, company,
            or other group, “Client”, “You” and “Your” refers to both you
            personally as well as the organization you are representing.
            Furthermore, by representing an organization on this website, you
            affirm that you have the authority to enter into agreements on
            behalf of that organization. “Company”, “Our”, “Ourselves”, “We” and
            “Us”, refers to Next Health Media LLC, d/b/a Reachello, a Ohio company.
            “Party”, “Parties”, or “Us”, refers to both the Client and ourselves
            when plural, or either the Client or ourselves when singular.
            “Services” and “Products” refer to anything that we offer for you to
            use or consume, including services which may be registered for
            online but may be accessed, at least in part, offline. “Website”,
            “Site”, and “Portal” refer to content, software, applications, and
            services accessed on or through our domain, reachello.com, including
            any subdomains.
          </p>

          <p>
            Any use of the above terminology or other words in the singular,
            plural, capitalization and/or he/she or they, are taken as
            interchangeable if not otherwise defined separately and therefore as
            referring to same.
          </p>
        </div>

        <h4 className="text-primary-new fw-bold">Summary</h4>

        <p className="text-dark">
          These Terms and Conditions govern the use of our site for any purpose,
          including but not limited to browsing, using our software or
          applications, purchasing physical products, registering for services
          that may be accessed offline or otherwise, and sharing information or
          content with us, in accordance with and subject to prevailing law.
        </p>

        <h4 className="text-primary-new fw-bold">Privacy Statement</h4>

        <p className="text-dark">
          Our privacy policy can be found at{" "}
          <Link
            to="/privacy-policy"
            className="text-primary fw-bold text-decoration-none"
          >
            Privacy policy
          </Link>{" "}
          and is hereby incorporated herein by reference in its entirety.
        </p>

        <h4 className="text-primary-new fw-bold mb-3">Disclaimer</h4>

        <h6 className="text-primary-new fw-bold">Exclusions and Limitations</h6>

        <p className="text-dark">
          The information on this web site is provided on an “as is” basis. To
          the fullest extent permitted by law, the Company: (a) excludes all
          representations and warranties relating to this website and its
          contents or which is or may be provided by any affiliates or any other
          third party, including in relation to any inaccuracies or omissions in
          this website and/or the Company's literature; and, (b) excludes all
          liability for damages arising out of or in connection with your use of
          this website and our services. This includes, without limitation,
          direct loss, loss of business or profits (whether or not the loss of
          such profits was foreseeable, whether or not it arose in the normal
          course of things, and whether or not you have advised the Company of
          the possibility of such potential loss), damage caused to your
          computer, computer software, systems and programs and the data thereon
          or any other direct or indirect, consequential and incidental damages.
          The Company does not however exclude liability for death or personal
          injury caused by its negligence. The above exclusions and limitations
          apply only to the extent permitted by law. None of your statutory
          rights as a consumer are affected.
        </p>

        <h4 className="text-primary-new fw-bold">Consent and Authorization</h4>

        <p className="text-dark">
          Client agrees as a condition of ordering any testing services provided
          by the Company for another individual other than themselves to obtain
          written consent to testing and authorization for release of test
          results to the Company and the Client. This applies to each and every
          individual for whom Client orders testing services from the Company.
          The consent for testing and authorization for release of results shall
          be provided by the Client to the Company in either electronic or paper
          form upon request, and shall be obtained by Client prior to that
          individual being sent for testing. Such consent and authorization
          shall be obtained from the individual using a waiver that identifies
          the Company as the representative of the Client, and which contains
          the individual's authorization to obtain the results of the
          individual's results, such as drug test results or occupational health
          testing results, in physical or electronic form, and sharing of those
          test results with the Client prior to releasing the results to the
          individual. The waiver shall provide the individual's agreement to
          release, indemnify and hold harmless the Company and the Client from
          any responsibility or damages related to transmittal of results for
          any testing performed pursuant to this Agreement.
        </p>

        {/* <h4 className="text-primary-new fw-bold mb-3">Services Offered</h4>

        <h6 className="text-primary-new fw-bold">Drug Testing Services:</h6>

        <p className="text-dark">
          Company will provide or arrange for specimen collection services as
          ordered. Lab-based drug testing services also include laboratory
          analysis. Instant drug testing services do not include lab analysis
          unless non-negative. MRO review of results is included with all drug
          tests except on-site instant testing where permitted by state law.
        </p>

        <h6 className="text-primary-new fw-bold">DNA Tests</h6>

        <p className="text-dark">
          Company will provide or arrange for specimen collection services as
          ordered. DNA tests include lab analysis of specimens and statistical
          analysis of results.
        </p>

        <h6 className="text-primary-new fw-bold">
          DNA Tests in New York State
        </h6>

        <p className="text-dark">
          The following regulations apply to any DNA tests in New York State
          only:
        </p>

        <ul className="text-dark">
          <li>
            A physician's prescription is required for a DNA test in the State
            of New York.
          </li>
          <li>
            Non-legal DNA testing is not available in the State of New York.
          </li>
          <li>
            Lab fees of $45 per person must be paid directly to the laboratory
            that processes your test.
          </li>
        </ul>

        <h6 className="text-primary-new fw-bold">Background Checks</h6>

        <p className="text-dark">
          Background checks require a separate agreement between you and us. If
          you order a background check on this website, you understand that you
          will have to sign that agreement on behalf of your company before we
          can proceed with the screens you request. We also require that you
          provide evidence that the people you want to screen have authorized
          you to do so. We will provide an electronic waiver that they can
          electronically sign and return to us along with their photo ID. Unless
          we agree otherwise in special circumstances, this signed waiver plus a
          copy of their government issued photo ID is required before we will
          run the background check.
        </p>

        <h6 className="text-primary-new fw-bold">
          Independent Contractor Status
        </h6>

        <p className="text-dark">
          The Company and its contracted providers that will provide services
          pursuant to this Agreement shall function at all times as independent
          contractors to Client and not as employees, agents or representatives
          of Client.
        </p> */}

        <h4 className="text-primary-new fw-bold">Availability</h4>

        <p className="text-dark">
          Unless otherwise stated, the services featured on this website are
          only available within the United States. All advertising is intended
          solely for the United States market. Direct to consumer drug testing
          services are unavailable to Maryland residents. Any tests or services
          on our website that are prohibited by law in the state in which you
          wish to arrange for the test or service are unavailable to you. You
          are solely responsible for evaluating the fitness for a particular
          purpose of any downloads, programs and text available through this
          site. Redistribution or republication of any part of this site or its
          content is prohibited, including such by framing or other similar or
          any other means, without the express written consent of the Company.
          The Company does not warrant that the service from this site will be
          uninterrupted, timely or error free, although it is provided to the
          best ability.
        </p>

        <h4 className="text-primary-new fw-bold mb-3">
          Payment, Cancellation and Returns Policy
        </h4>

        <h6 className="text-primary-new fw-bold">Cost of Services</h6>

        <p className="text-dark">
          Services ordered pursuant to this agreement are billable at the rates
          that are listed on Company's website at the time the Client registers
          for services.
        </p>

        <h6 className="text-primary-new fw-bold">Payment for Services</h6>

        <p className="text-dark">
          The obligations of the Parties to perform and pay for testing services
          arise upon the execution by the Client of an order, which can be
          placed by the Client electronically by placing orders on the Company's
          website, telephonically by calling the Company, or by email
          transmission to the Company. Orders are then processed by the Company,
          such as through the issuance of a barcode or other authorization for
          services to be performed. Services may be accessed at a later time or
          date.
        </p>

        <p className="text-dark">
          All major Credit/Debit Cards are all acceptable methods of payment.
          Our payment terms are payment in full upon the ordering of a service.
          All goods remain the property of the Company until paid for in full.
          Businesses may apply for credit accounts. There are no refunds once
          payment is made. Clients receive a lifetime credit for unused prepaid
          services, with certain exceptions as noted below. A drug testing
          service is considered “used” and not eligible for future credit when
          any of the following occurs:
        </p>

        <ul className="text-dark">
          <li>A service is accessed or used</li>
          <li>A product is shipped</li>
          <li>
            A person “refuses” a test by method or manner consistent with the US
            DOT definition of a refusal in 49 CFR Part 40.
          </li>
          <li>
            An affidavit of no-show for testing is requested by Client. (Reachello can provide an affidavit of “no-show” for services
            that are not used; if you choose to request such an affidavit, you
            forfeit the lifetime credit that would otherwise be available to
            you).
          </li>
          <li>
            Short-notice mobile testing is considered used immediately and in
            full upon order and is not refundable. (Short notice testing is not
            subject to our Lifetime Credit Policy).
          </li>
        </ul>

        <h4 className="text-primary-new fw-bold">
          On-site and mobile testing:
        </h4>

        <p className="text-dark">
          Additional charges may accrue when a client orders on-site testing if
          certain overages occur, and Client agrees to promptly pay Company for
          such overages. Overages include: (a) mileage over 50 miles roundtrip,
          (b) Wait time if Reachello visits Client location at the time
          requested by Client but Client (or Employee(s)) is not available or
          ready for testing to begin, or if Reachello must wait beyond 30
          minutes because of a shy bladder; (c) when additional tests are
          required on-site, such as additional people to test, a breath alcohol
          test (BAT) confirmation for non-negative screening (billed as a second
          BAT), or a second chain of custody is required (billed as a second
          drug test).
        </p>

        <h4 className="text-primary-new fw-bold">Lifetime Credit:</h4>

        <p className="text-dark">
          Clinic based drug and alcohol testing services that are not used by
          Client can be re-used any time. There is a lifetime credit for unused
          services. Tests unused by one employee can be transferred to another
          at no charge.
        </p>

        <h4 className="text-primary-new fw-bold">Timeframe for Results</h4>

        <p className="text-dark">
          Reachello understands how important it is for our clients to get
          timely results for tests. We also understand that an estimated
          timeframe is important for you to gauge when to expect results. We
          make every effort to provide reasonable estimates for results;
          however, as much as we wish we could, we never guarantee timeframes
          for results. There are a number of reasons that explain why we do not
          guarantee timeframes for results, including:
        </p>

        <ul className="text-dark">
          <li>
            Specimens are typically shipped to our central labs, and shipping
            can be delayed due to weather, mechanical failure, missed cut-off
            times, etc.
          </li>
          <li>
            specimens vary, and sometimes the specimens can require re-testing,
            confirmation testing, or additional testing
          </li>
          <li>
            while lab tests are conducted as scientific processes, ultimately,
            virtually all of our tests require expert analysis. These analyses,
            in some instances, are more complicated than expected, and may
            require extra time to provide you with accurate results.
          </li>
          <li>
            Instant Background Checks are database checks that typically come
            back within 24 hours.
          </li>
          <li>
            Detailed Background Checks are manual labor, and often rely on
            states, counties, or employers to get back to us with information.
            Therefore, detailed checks typically take about 3 days to a week to
            complete. This timeframe varies by who and what we are checking for
            you.
          </li>
        </ul>

        <p className="text-dark">
          Ultimately, while we strive to provide accurate results quickly,
          Reachello prioritizes accuracy over timeliness.
        </p>

        <h4 className="text-primary-new fw-bold">Portal Access</h4>

        <p className="text-dark">
          When you register an organization on our Portal, you affirm that you
          have the authority to sign agrements on behalf of that organization.
          If you do not have such authority, you should not register the
          organization. The person who registers the organization is designated
          as a “superuser” for that organization, which provides full access to
          the company's data stored on the Portal, including data shared with
          the company by other individuals. The superuser can grant access to
          other individuals within their organization. The Client acknowledges
          that only the superuser, or others designated as such by another
          superuser, will be responsible for whom, within their organization,
          has access to the organization’s data on the Portal. The Client alone
          is independently responsible for determining who is granted access to
          their organization's data on the Portal, as well as for removing
          access from individuals who should no longer have access to their
          data. If the superuser leaves the organization without delegating
          their full access authority to anyone else, the Company may accept
          alternative means to transfer superuser access, such as a notarized
          letter on company letterhead requesting that the superuser be changed
          to someone else.
        </p>

        <h4 className="text-primary-new fw-bold">
          Indemnification and Hold Harmless
        </h4>

        <p className="text-dark">
          Client shall indemnify, defend and save harmless the Company and its
          officers, directors, employees and agents, from and against all
          liability, loss, cost or expense (including attorney's fees) by reason
          of liability imposed upon the Company, arising out of or related to
          the Company's services, whether caused by, or contributed to by, the
          Company or any other party indemnified herein, including losses
          arising from third party claims brought against Company for bodily
          injury, economic or reputational harm, emotional or psychological
          injuries or damage to real or tangible personal property arising from
          services ordered under this Agreement, unless caused solely by the
          gross negligence of the Company, and/or its officers, directors,
          employees and agents. Company shall not be held liable for any and all
          claims, losses, expenses, injuries, or damages arising out of or in
          any way related to these services or any aspect of these services by
          reason or any act or omission, including breach of contract or
          negligence not amounting to a willful or intentional wrong.
          Furthermore, the company's liability under this Agreement shall not
          exceed the total amount paid to the Company for the orders accepted by
          the company pursuant to this Agreement. The Company shall not be
          liable to the Client for any special or consequential damages,
          including but not limited to, lost profits, loss of use, and costs of
          replacement, caused by the Company's negligence, breach of contract,
          or any other cause whatsoever.
        </p>

        <h6 className="text-primary-new fw-bold">Exclusion of Damages</h6>

        <p className="text-dark">
          NEITHER PARTY WILL HAVE ANY OBLIGATION FOR: (I) CONSEQUENTIAL,
          PUNITIVE, INCIDENTAL, INDIRECT OR REPUTATIONAL DAMAGES; (II) PROFIT,
          DATA OR REVENUE LOSS; OR (III) CAPITAL, REPLACEMENT OR INCREASED
          OPERATING COSTS.
        </p>

        <h4 className="text-primary-new fw-bold">Log Files</h4>

        <p className="text-dark">
          We use IP addresses to analyze trends, administer the site, track
          user's movement, and gather broad demographic information for
          aggregate use. Additionally, for systems administration, detecting
          usage patterns and troubleshooting purposes, we log standard access
          information including browser type, access times/open mail, URL
          requested, and referral URL.
        </p>

        <h4 className="text-primary-new fw-bold">Cookies</h4>

        <p className="text-dark">
          Although we may provide links to third party websites when deemed
          useful to our clients, we do not monitor or review the content of
          third party's websites which are linked to from this website. Opinions
          expressed or material appearing on such websites are not necessarily
          shared or endorsed by us and should not be regarded as the publisher
          of such opinions or material. Please be aware that we are not
          responsible for the privacy practices, or content, of these sites. We
          encourage our users to be aware when they leave our site & to read the
          privacy statements of these sites. You should evaluate the security
          and trustworthiness of any other site connected to this site or
          accessed through this site yourself, before disclosing any personal
          information to them. This Company will not accept any responsibility
          for any loss or damage in whatever manner, howsoever caused, resulting
          from your disclosure to third parties of personal information.
        </p>

        <h4 className="text-primary-new fw-bold">Links to this website</h4>

        <p className="text-dark">
          You may not create a link to any page of this website without our
          prior written consent. If you do create a link to a page of this
          website you do so at your own risk and the exclusions and limitations
          set out above will apply to your use of this website by linking to it.
        </p>

        <h4 className="text-primary-new fw-bold">Links from this website</h4>

        <p className="text-dark">
          Although we may provide links to third party websites when deemed
          useful to our clients, we do not monitor or review the content of
          third party's websites which are linked to from this website. Opinions
          expressed or material appearing on such websites are not necessarily
          shared or endorsed by us and should not be regarded as the publisher
          of such opinions or material. Please be aware that we are not
          responsible for the privacy practices, or content, of these sites. We
          encourage our users to be aware when they leave our site & to read the
          privacy statements of these sites. You should evaluate the security
          and trustworthiness of any other site connected to this site or
          accessed through this site yourself, before disclosing any personal
          information to them. This Company will not accept any responsibility
          for any loss or damage in whatever manner, howsoever caused, resulting
          from your disclosure to third parties of personal information.
        </p>

        <h4 className="text-primary-new fw-bold">Copyright Notice</h4>

        <p className="text-dark">
          “Reachello” and "Reachello" logo are registered trademarks of Next Health Media LLC, d/b/a Reachello. Any reproduction, use, or imitation of the
          logo, in any fashion, without prior written consent, is strictly
          prohibited.
        </p>

        <h4 className="text-primary-new fw-bold">User Submitted Content</h4>

        <p className="text-dark">
          We may provide opportunities for users to submit content to us, such
          as commenting on our blog articles, reviewing our products, and
          submitting guest blog posts. If such content is submitted by you, you
          hereby grant us a perpetual worldwide license to use that content for
          any purpose, including making it publicly available on our site and
          sharing it with third parties. User submitted content is not
          considered confidential. Furthermore, we are not obligated to
          compensate you in any way for your user submitted content. If you wish
          to have your own user submitted content removed from our site after
          you have submitted it, you may contact us to make that request, and it
          will generally be honored in an expeditious manner.
        </p>

        <h4 className="text-primary-new fw-bold">Force Majeure</h4>

        <p className="text-dark">
          Neither party shall be liable to the other for any failure to perform
          any obligation under any Agreement which is due to an event beyond the
          control of such party including but not limited to any Act of God,
          terrorism, war, Political insurgence, insurrection, riot, civil
          unrest, act of civil or military authority, uprising, earthquake,
          flood or any other natural or man made eventuality outside of our
          control, which causes the termination of an agreement or contract
          entered into, nor which could have been reasonably foreseen. Any Party
          affected by such event shall forthwith inform the other Party of the
          same and shall use all reasonable endeavors to comply with the Terms
          and Conditions of any Agreement contained herein.
        </p>

        <h4 className="text-primary-new fw-bold">Waiver</h4>

        <p className="text-dark">
          Failure of either Party to insist upon strict performance of any
          provision of this or any Agreement or the failure of either Party to
          exercise any right or remedy to which it, he or they are entitled
          hereunder shall not constitute a waiver thereof and shall not cause a
          diminution of the obligations under this or any Agreement. No waiver
          of any of the provisions of this or any Agreement shall be effective
          unless it is expressly stated to be such and signed by both Parties.
        </p>

        <h4 className="text-primary-new fw-bold">General</h4>

        <p className="text-dark">
          This Agreement and the use of our website shall be governed by and
          construed in accordance with the laws of the State of New York,
          without reference to principles of conflicts of law. By accessing this
          website and using our services or products, you consent to these Terms
          and Conditions and to the exclusive jurisdiction of the New York
          courts in all disputes arising out of such access. In the event that
          any provision of this Agreement is found to be void or unenforceable,
          the remaining provisions of this Agreement shall nevertheless be
          binding upon the Parties hereto with the same effect as though the
          void or unenforceable provision had been severed and deleted. Failure
          of the Company to enforce any of the provisions set out in these Terms
          and Conditions and any Agreement, or failure to exercise any option to
          terminate, shall not be construed as waiver of such provisions and
          shall not affect the validity of these Terms and Conditions or of any
          Agreement or any part thereof, or the right thereafter to enforce each
          and every provision. This Agreement is not intended and shall not be
          construed to confer any benefit on any person who is not a Party
          hereto. Neither Party shall assign or transfer its rights, duties, or
          obligations under this Agreement without the other Party’s prior
          written consent. This Agreement shall be binding upon and shall inure
          to the benefit of the Parties and their respective successors,
          permitted assigns and legal representatives.
        </p>

        <h4 className="text-primary-new fw-bold">Prevailing Agreement</h4>

        <p className="text-dark">
          This agreement represents the entire agreement and understanding
          between the Parties with respect to the subject matter. Any waiver of
          any right under this agreement, and any amendment to this agreement,
          must be signed in a separate document signed by the Parties. In the
          event of any conflict between the provisions of these Terms and
          Conditions and the provisions of a separately signed agreement entered
          into between the parties, the provisions of this agreement will
          prevail unless the separate agreement specifically identifies the
          conflict and specifies that it prevails. Any separate agreement signed
          by the parties prior to the Date of Last Modification on this page is
          subordinate to this agreement. In any event, the validity of
          provisions of these Terms and Conditions which are not in conflict
          with such separate agreements will not be affected.
        </p>

        <h4 className="text-primary-new fw-bold">Term and Termination</h4>

        <p className="text-dark">
          This agreement will remain in effect on an “evergreen” basis. However,
          the Company reserves the right to amend, modify, vary, supplement, or
          otherwise change these conditions from time to time as it sees fit.
          Your continued use of the site and our services will signify your
          acceptance of any changes. The agreement can also be canceled by
          Client by notifying us of your desire to cancel via email at
          support@reachello.com.
        </p>

        <h4 className="text-primary-new fw-bold">Notification of Changes</h4>

        <p className="text-dark">
          If these Terms and Conditions are adjusted, we will announce that
          changes have been made by updating the Date of Last Modification on
          this page. Similarly, if there are any changes to our privacy policy,
          we will announce that these changes have been made by updating the
          date of last modification on our privacy page, found at:{" "}
          <Link
            to="/privacy-policy"
            className="text-primary fw-bold text-decoration-none"
          >
            Privacy Policy
          </Link>
          . You are therefore advised to re-read this page on a regular basis if
          you continue to use our services and/or website. These Terms and
          Conditions form an Agreement between You and Us. In the case you are
          representing a company or other organization, these Terms and
          Conditions form an agreement between your organization and us. Your
          accessing of this website and/or registering or booking a service or
          making a purchase from us indicates your understanding, agreement, and
          acceptance of the Privacy Policy and the full Terms and Conditions
          contained herein. Your statutory Consumer Rights are unaffected.
        </p>

        <h5 className="text-primary-new fw-bold">Date of Last Modification</h5>

        <h5 className="text-primary-new fw-bold">December 5,2022</h5>
      </div>
    </>
  );
};

export default TermsConditionsFooter;
